import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-form text-center" }
const _hoisted_2 = {
  class: "font-normal text-[41.5px] mt-[108px]",
  id: "welcome-message"
}
const _hoisted_3 = {
  class: "font-normal text-[#515659] mb-[78px]",
  id: "mgmt-message"
}
const _hoisted_4 = {
  class: "bg-white border-2 border-gray-300 w-[420px] h-[250px] m-auto p-[30px]",
  id: "login-box"
}
const _hoisted_5 = {
  class: "font-normal text-[24.5px] mb-8 mt-2",
  id: "login-title"
}

import nanooSecurityLogo from './nanooSecurityLogo.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

    function login() {
        window.location.href =
            process.env.VUE_APP_SDREAMLAND_BACKEND_URL + '/login/external/services/ms'
    }

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('login.welcome')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('login.managementTool')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('login.loginTitle')), 1),
      _createVNode(_component_v_btn, {
        variant: "outlined",
        onClick: login,
        height: "80px",
        width: "350px",
        id: "login-button"
      }, {
        default: _withCtx(() => [
          _createVNode(nanooSecurityLogo, { id: "nanoo-security-logo" })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})